__turbopack_context__.v({
  "popoverBody": "index-module__7ZE9PW__popoverBody",
  "previewVideoPlayer": "index-module__7ZE9PW__previewVideoPlayer",
});
